module.exports = __webpack_public_path__ + "static/media/profile-avatar.995ca3cc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/images/profile-avatar.jpeg
// module id = 192
// module chunks = 0